import { render, staticRenderFns } from "./Osa004.vue?vue&type=template&id=54edba48&scoped=true"
var script = {}
import style0 from "./Osa004.vue?vue&type=style&index=0&id=54edba48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54edba48",
  null
  
)

export default component.exports